/* eslint-disable no-useless-escape */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import Tab from '../../components/Tab';
import { useFetch } from '../../hooks/useFetch';
import './Election.scss';
import ListCandidates from './listCandidates';
import {
  JSONGobMex,
  JSONPresBr,
  JSONDefault,
  JSONPresPr,
  JSONPresPrPercent,
  JSONPresBrBack } from '../../utils/JSONElections';
import {
  mexico,
  brasil,
  initial,
  peru,
  peruPercent,
  brasilVuelta } from './States';

const Election = () => {
  /** URL Params*/
  const [searchParams] = useSearchParams();
  const paramsEstado = searchParams.get('estado');
  const showButtons = searchParams.get('showButtons') === 'true' ?  true : false;
  const year = searchParams.get('year');
  const country = searchParams.get('country');
  const type = searchParams.get('type');
  const ISOCountry = searchParams.get('ISOCountry');
  const position = searchParams.get('position');
  const shortVersion = searchParams.get('shortVersion') === 'true' ? true : false;
  const showResume = searchParams.get('showResume') === 'true' ? true : false;
  const theme = searchParams.get('theme') || '';
  const getLimit = searchParams.get('limit');
  const limit = parseInt(getLimit);
  const limitLenght = limit ? true : false;
  const showVotes = searchParams.get('showVotes') === 'false' ? false : true;
  const formatNumber = searchParams.get('formatNumber') === 'true' ? true : false; 
  
  /** URL Create*/
  const BASIC_URL = 'https://data-ecp.infobae.com/infobae.com/';
  const URL_getDataWithParams = `${BASIC_URL}${year}/${country}/${type}/${ISOCountry}_${position}.json?timestamp=${new Date().getTime()}`;

  /** States*/
  const [states, setStates] = useState(initial);
  const [JSONState, setJSONState] = useState(JSONDefault);
  const [toggleState, setToggleState] = useState(0);
  const currentUrl = showButtons ? (toggleState !== 0 ? states[toggleState]?.url : URL_getDataWithParams) : URL_getDataWithParams;
  
  const capitalizeLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  const currentState = showButtons ? (states[toggleState].state || capitalizeLetter(country)) : capitalizeLetter(country);

  const [data, loading, , fetchData] = useFetch();

  const findEstado = states.find((estado) => estado.state === paramsEstado);

  if (findEstado) {
    states.sort((a, _b) => {
      if (a.id === findEstado.id) {
        return -1;
      }
      return 1;
    });
  }

  const toggleTab = (index) => {
    setToggleState(index);
  };

  const showSkeleton = () => {
    if (limitLenght) {
      return JSONState[currentState]?.parties?.map((e, index) => (
        index <= limit - 1
        ? 
          <div key={index} className={`g-container__skeleton-item`} />
        :
          null
      ))
    }

    if (!limitLenght) {
      return JSONState[currentState]?.parties?.map((e, i) => (
        <div key={i} className="g-container__skeleton-item" />
      ))
    }

    return null
  }

  const EstatusCandidates = () => {
    if (loading) {
      return (
        <>
          <div className="g-container__skeleton-container">
          {showSkeleton()}
          </div>
          {showResume && <div className="g-container__skeleton-footer" />}
        </>
      );
    }
    return <ListCandidates 
      currentState={currentState} 
      currentData={data} 
      JSONState={JSONState} 
      shortVersion={shortVersion} 
      showResume={showResume} 
      limit={limit}
      limitLenght={limitLenght}
      showVotes={showVotes}
      country={country}
      theme={theme}
      formatNumber={formatNumber} />;
  };

  useEffect(() => {
    fetchData(currentUrl);
  }, [toggleState]);

  useEffect(() => {
    switch(country) {
      case 'méxico':
        setStates(mexico);
        setJSONState(JSONGobMex);
        break;
      case 'brasil':
        if (type === 'general_vuelta') {
          setStates(brasilVuelta);
          setJSONState(JSONPresBrBack);
        } else {
          setStates(brasil);
          setJSONState(JSONPresBr);
        }
        break;
      case 'perú':
        if (type?.split('-')[1] === 'porcentaje') {
          setStates(peruPercent);
          setJSONState(JSONPresPrPercent);
        } else {
          setStates(peru);
          setJSONState(JSONPresPr);
        }
        break;
      default:
        setStates(initial);
        setJSONState(JSONDefault);
    };
  }, []);

  return (
    <div className={ theme === 'dark' ? 'g-container dark' : 'g-container'}>
      {showButtons && states.length > 1 && <Tab toggleTab={toggleTab} toggleState={toggleState} estados={states} />}
      {EstatusCandidates()}
    </div>
  );
};

export default Election;
